import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { emailValidator, validateAllFormFields } from '../../../models/customValidators'
import { RestServices } from '../../services/rest.services'

@Component({
    selector: 'app-campaign',
    templateUrl: './campaign.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class CampaignComponent implements OnInit {

    en = {}
    showEN = true
    apply = false
    str: any
    statusEmail: string
    campFormGroup: FormGroup
    statusSubmit = false

    constructor(private auth: AuthService, private formBuider: FormBuilder, private checkFormat: RestServices) {
        this.validatorForm()
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    validatorForm() {
        this.campFormGroup = this.formBuider.group({
            email: ['', [Validators.required, emailValidator()]],
            contact: ['', Validators.required],
            code: ['', Validators.required],
        })
    }

    // check format email server
    checkFormatEmail() {
        const format = this.campFormGroup.value.email.slice(this.campFormGroup.value.email.search('@') + 1)
        this.checkFormat.http_post('form/checkMx', { host: format }).subscribe(
            response => {
                this.str = response['status']
            },
        )
    }

    isFieldValid(field: string) {
        if (this.statusSubmit === true) {
            return !this.campFormGroup.get(field).valid && this.campFormGroup.get(field).touched // remove (!this.campFormGroup.get(field).valid && this.campFormGroup.get(field).touched || ))
        } else {
            return this.campFormGroup.get(field).dirty && (this.campFormGroup.get(field).status === 'INVALID') // remove (!this.campFormGroup.get(field).valid && this.campFormGroup.get(field).touched || ))
        }
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
        }
    }

    onSubmit() {
        if (this.campFormGroup.valid) {
            this.apply = true
        } else {
            validateAllFormFields(this.campFormGroup)
            this.statusSubmit = true
        }
    }

    // submit apply
    submitApply() {
        const lang = localStorage.getItem('lang') === 'true' ? 'en' : 'ja'
        const body = {
            data: { type: 'registration', email: this.campFormGroup.value.email },
            type: 'registration',
            lang: lang,
        }
        this.checkFormat.http_post('form', body).subscribe(
            success => {
                this.statusEmail = success['status']
            },
        )
    }

    // back form
    reset() {
        this.apply = false
        this.statusEmail = 'no'
    }

}



// WEBPACK FOOTER //
// ./src/app/promotion/campaign/campaign.component.ts